import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import {
  ButtonTertiary,
  Type,
  screenXsMin,
  spacer16,
  spacer40,
} from '@spotify-internal/encore-web';
import { useTracking } from '../../Tracking';

import { HELP_LIST_TRACK_CAT, hidden } from '../../Help/util';
import { useT } from '@spotify-internal/i18n-core';

const InfoHelpful = styled.div<any>`
  padding: ${spacer40} 0;
`;

const Divider = styled.hr`
  border: 1px solid ${({ theme }) => theme.box.text};

  @media (max-width: ${screenXsMin}) {
    ${hidden}
  }
`;

const CTAButton = styled(ButtonTertiary)`
  margin-right: ${spacer16};
  color: ${({ theme }) => theme.box.text};
  border: ${({ theme }) => `${theme.box.text} 1px solid`};
  &:hover:not(:focus):not(:disabled),
  &:active:not(:disabled),
  &:focus:not(:disabled),
  &.highlight {
    color: ${({ theme }) => theme.box.background};
    background-color: ${({ theme }) => theme.box.text};
  }
`;

const Message = styled(Type.h4).attrs({
  variant: 'cello',
})`
  text-align: left;
  padding-bottom: ${spacer16};
`;

const Buttons = styled.div``;

export const ArticleFeedbackModule: React.FC = () => {
  const { eventHandler } = useTracking();
  const [feedbackReceived, setFeedbackReceived] = useState(false);
  const t = useT();

  const router = useRouter();
  const path = router.asPath;

  useEffect(() => {
    setFeedbackReceived(false);
  }, [router.asPath]);

  return (
    <InfoHelpful>
      <Divider />
      <Message>
        {t('FRODOR_377c48', 'Was this information helpful?', '')}
      </Message>
      {!feedbackReceived ? (
        <Buttons>
          <CTAButton
            onClick={e => {
              setFeedbackReceived(true);
              eventHandler(HELP_LIST_TRACK_CAT, `${path} InfoHelpful - Yes`)(e);
            }}
          >
            {t('FRODOR_b00cc1', 'Yes', '')}
          </CTAButton>
          <CTAButton
            onClick={e => {
              setFeedbackReceived(true);
              eventHandler(HELP_LIST_TRACK_CAT, `${path} InfoHelpful - No`)(e);
            }}
          >
            {t('FRODOR_c265e7', 'No', '')}
          </CTAButton>
        </Buttons>
      ) : (
        <>{t('FRODOR_6fb6f2', 'Thank you for your feedback!', '')}</>
      )}
    </InfoHelpful>
  );
};
